// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sm-function-module-content[data-v-7e4ba438] {\n  margin: 0;\n}\n@media (max-height: 450px) {\n.sm-function-module-content[data-v-7e4ba438] {\n    overflow: hidden;\n    padding: 0 15px;\n    max-height: 420px;\n    max-width: 280px;\n}\n}\n.sm-input-long[data-v-7e4ba438] {\n  float: right;\n  width: 35%;\n}\n.sm-function-module-sub-section[data-v-7e4ba438] {\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
